import { render, staticRenderFns } from "./k-browser-content.vue?vue&type=template&id=925608fc&lang=pug&"
import script from "./k-browser-content.vue?vue&type=script&lang=js&"
export * from "./k-browser-content.vue?vue&type=script&lang=js&"
import style0 from "./k-browser-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('925608fc')) {
      api.createRecord('925608fc', component.options)
    } else {
      api.reload('925608fc', component.options)
    }
    module.hot.accept("./k-browser-content.vue?vue&type=template&id=925608fc&lang=pug&", function () {
      api.rerender('925608fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-browser-content.vue"
export default component.exports